import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindow, BrowserWindowSymbol, FeatureExportsSymbol } from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './index'
import { ServiceBinding, ServiceFactoryOpts } from '@wix/services-manager/types'
import {
	ISiteScrollBlockerDefinition,
	ISiteScrollBlockerServiceConfig,
	ISiteScrollBlockerService,
	SiteScrollBlockerDefinition,
	SiteScrollBlockerService,
} from '@wix/site-scroll-blocker-service'
import { getSiteScrollBlockerConfig } from './siteScrollBlockerConfig'

export const SiteScrollBlockerServiceFactory = withDependencies(
	[BrowserWindowSymbol, named(FeatureExportsSymbol, name)],
	(
		browserWindow: BrowserWindow,
		siteScrollBlockerExports: IFeatureExportsStore<typeof name>
	): ServiceBinding<
		ISiteScrollBlockerDefinition,
		(opts: ServiceFactoryOpts<ISiteScrollBlockerServiceConfig>) => ISiteScrollBlockerService
	> => {
		const config = getSiteScrollBlockerConfig(browserWindow, siteScrollBlockerExports)

		return {
			definition: SiteScrollBlockerDefinition,
			impl: SiteScrollBlockerService,
			config,
		}
	}
)
